var React = require('react');
var ReactDOM = require("react-dom");

var PT = React.PropTypes;

// Takes an array of components to sort
var SortableArea = React.createClass({
    displayName: 'SortableArea',

    propTypes: {
        className: PT.string,
        components: PT.arrayOf(PT.node).isRequired,
        onReorder: PT.func.isRequired,
        style: PT.any,
        verify: PT.func
    },
    getDefaultProps: function getDefaultProps() {
        return { verify: function verify() {
                return true;
            } };
    },
    getInitialState: function getInitialState() {
        return {
            // index of the component being dragged
            dragging: null,
            components: this.props.components
        };
    },
    // Firefox refuses to drag an element unless you set data on it. Hackily
    // add data each time an item is dragged.
    componentDidMount: function componentDidMount() {
        this._setDragEvents();
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        this.setState({ components: nextProps.components });
    },
    componentDidUpdate: function componentDidUpdate() {
        this._setDragEvents();
    },
    // Alternatively send each handler to each component individually,
    // partially applied
    onDragStart: function onDragStart(startIndex) {
        this.setState({ dragging: startIndex });
    },
    onDrop: function onDrop() {
        // tell the parent component
        this.setState({ dragging: null });
        this.props.onReorder(this.state.components);
    },
    onDragEnter: function onDragEnter(enterIndex) {
        // When a label is first dragged it triggers a dragEnter with itself,
        // which we don't care about.
        if (this.state.dragging === enterIndex) {
            return;
        }

        var newComponents = this.state.components.slice();

        // splice the tab out of its old position
        var removed = newComponents.splice(this.state.dragging, 1);
        // ... and into its new position
        newComponents.splice(enterIndex, 0, removed[0]);

        var verified = this.props.verify(newComponents);
        if (verified) {
            this.setState({
                dragging: enterIndex,
                components: newComponents
            });
        }
        return verified;
    },
    _listenEvent: function _listenEvent(e) {
        e.dataTransfer.setData('hackhackhack', 'because browsers!');
    },
    _cancelEvent: function _cancelEvent(e) {
        // prevent the browser from redirecting to 'because browsers!'
        e.preventDefault();
    },
    _setDragEvents: function _setDragEvents() {
        this._dragItems = this._dragItems || [];
        var items = ReactDOM.findDOMNode(this).querySelectorAll('[draggable=true]');

        var oldItems = [];
        var newItems = [];

        for (var i = 0; i < this._dragItems.length; i++) {
            var item = this._dragItems[i];
            if (items.indexOf(item) < 0) {
                oldItems.push(item);
            }
        }

        for (var _i = 0; _i < items.length; _i++) {
            var _item = items[_i];
            if (this._dragItems.indexOf(_item) < 0) {
                newItems.push(_item);
            }
        }

        for (var _i2 = 0; _i2 < newItems.length; _i2++) {
            var dragItem = newItems[_i2];
            dragItem.addEventListener('dragstart', this._listenEvent);
            dragItem.addEventListener('drop', this._cancelEvent);
        }

        for (var _i3 = 0; _i3 < oldItems.length; _i3++) {
            var _dragItem = oldItems[_i3];
            _dragItem.removeEventListener('dragstart', this._listenEvent);
            _dragItem.removeEventListener('drop', this._cancelEvent);
        }
    },
    render: function render() {
        var _this = this;

        var sortables = this.state.components.map(function (component, index) {
            return React.createElement(SortableItem, {
                index: index,
                component: component,
                area: _this,
                key: component.key,
                draggable: component.props.draggable,
                dragging: index === _this.state.dragging
            });
        });
        return React.createElement(
            'ol',
            { className: this.props.className, style: this.props.style },
            sortables
        );
    }
});

// An individual sortable item
var SortableItem = React.createClass({
    displayName: 'SortableItem',

    propTypes: {
        area: PT.shape({
            onDragEnter: PT.func.isRequired,
            onDragStart: PT.func.isRequired,
            onDrop: PT.func.isRequired
        }),
        component: PT.node.isRequired,
        dragging: PT.bool.isRequired,
        draggable: PT.bool.isRequired,
        index: PT.number.isRequired
    },
    handleDragStart: function handleDragStart(e) {
        e.nativeEvent.dataTransfer.effectAllowed = "move";
        this.props.area.onDragStart(this.props.index);
    },
    handleDrop: function handleDrop() {
        this.props.area.onDrop(this.props.index);
    },
    handleDragEnter: function handleDragEnter(e) {
        var verified = this.props.area.onDragEnter(this.props.index);
        // Ideally this would change the cursor based on whether this is a
        // valid place to drop.
        e.nativeEvent.dataTransfer.effectAllowed = verified ? "move" : "none";
    },
    handleDragOver: function handleDragOver(e) {
        // allow a drop by preventing default handling
        e.preventDefault();
    },
    render: function render() {
        var dragState = "sortable-disabled";
        if (this.props.dragging) {
            dragState = "sortable-dragging";
        } else if (this.props.draggable) {
            dragState = "sortable-enabled";
        }

        return React.createElement(
            'li',
            { draggable: this.props.draggable,
                className: dragState,
                onDragStart: this.handleDragStart,
                onDrop: this.handleDrop,
                onDragEnter: this.handleDragEnter,
                onDragOver: this.handleDragOver
            },
            this.props.component
        );
    }
});

module.exports = SortableArea;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-components/sortable.jsx
 ** module id = 196
 ** module chunks = 0 2
 **/